import { createStore } from '@shared/store';
import {
  CaseIDProps,
  ServiceLocationDetailsObjectType,
  BinaryOptionsType,
} from '@types';
import { addressResponseType } from '@utils';

export type DateFieldType = string | number;
export type SelectedDate = {
  selectedDay: DateFieldType;
  selectedMonth: DateFieldType;
  selectedYear: DateFieldType;
};
interface PlanningBreachStoreType {
  sessionId: string;
  uploadedImages: string[];
  uploadedImagesFileName: string[];
  uploadedImagesFileType: string[];
  uploadedImagesBlob: {
    blob_uri: string;
    blob_endpoint: string;
    filename: string;
  }[];
  serviceLocationDetailsFromFile: ServiceLocationDetailsObjectType;
  fileWithLoadedCoordinates: string;
  isPhotoLocationStored: boolean;
  issueLocationData: addressResponseType;
  issueType: string;
  selectedDate: SelectedDate;
  issueInfo: string;
  howConditionBreached: string;
  propertyUsage: string;
  locationOfIssueInfo: string;
  specialCharactarists: BinaryOptionsType | 'DoNotKnow';
  detailsOfSpecialChars: string;
  doesOwnerLiveAtProperty: BinaryOptionsType | 'DoNotKnow';
  doesOwnerLiveAtPropertyDetails: string;
  whoIsResponsible: BinaryOptionsType;
  detailsOfResponsibility: string;
  problemInfo: string;
  shortTermLetsAd: BinaryOptionsType | 'DoNotKnow'; //1
  detailsOfShortTermLetsAd: string;
  worksCompletedDate: SelectedDate; //2
  anyMoreInfo: string;
  detailsOfAnyMoreInfo: string;
  receiveConfirmationEmail: String;
  confirmation: CaseIDProps | undefined;
  caseReferenceId: string;
  slaText: string;
  contactUserOption: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export const emptyLocation = {
  address_line_1: '',
  address_line_2: '',
  country: '',
  county: '',
  easting: '',
  latitude: '',
  longitude: '',
  northing: '',
  postcode: '',
  town: '',
  asset: undefined,
  UPRN: '',
  USRN: '',
  full_address: '',
};

const initialData = {
  sessionId: '',
  uploadedImages: [],
  uploadedImagesFileName: [],
  uploadedImagesFileType: [],
  uploadedImagesBlob: [],
  serviceLocationDetailsFromFile:
    [] as unknown as ServiceLocationDetailsObjectType,
  fileWithLoadedCoordinates: '',
  isPhotoLocationStored: false,
  issueLocationData: emptyLocation,
  issueType: '',
  selectedDate: {
    selectedDay: '',
    selectedMonth: '',
    selectedYear: '',
  },
  issueInfo: '',
  howConditionBreached: '',
  propertyUsage: '',
  locationOfIssueInfo: '',
  specialCharactarists: '' as BinaryOptionsType | 'DoNotKnow',
  detailsOfSpecialChars: '',
  doesOwnerLiveAtProperty: '' as BinaryOptionsType | 'DoNotKnow',
  doesOwnerLiveAtPropertyDetails: '',
  whoIsResponsible: '' as BinaryOptionsType,
  detailsOfResponsibility: '',
  problemInfo: '',
  shortTermLetsAd: '' as BinaryOptionsType | 'DoNotKnow',
  detailsOfShortTermLetsAd: '',
  worksCompletedDate: {
    selectedDay: '',
    selectedMonth: '',
    selectedYear: '',
  },
  anyMoreInfo: '' as BinaryOptionsType,
  detailsOfAnyMoreInfo: '',
  receiveConfirmationEmail: '',
  confirmation: undefined,
  caseReferenceId: '',
  slaText: '',
  contactUserOption: '',
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
};

export const resetIssueDetails = () => {
  usePlanningBreachStore
    .getState()
    .resetSelective([
      'uploadedImages',
      'uploadedImagesFileName',
      'uploadedImagesFileType',
      'uploadedImagesBlob',
      'fileWithLoadedCoordinates',
      'isPhotoLocationStored',
      'issueType',
      'howConditionBreached',
      'propertyUsage',
      'selectedDate',
      'issueInfo',
      'locationOfIssueInfo',
      'whoIsResponsible',
      'detailsOfResponsibility',
      'problemInfo',
      'shortTermLetsAd',
      'detailsOfShortTermLetsAd',
      'worksCompletedDate',
      'anyMoreInfo',
      'detailsOfAnyMoreInfo',
      'specialCharactarists',
      'detailsOfSpecialChars',
    ]);
};

export const usePlanningBreachStore = createStore<PlanningBreachStoreType>({
  initialData,
  name: 'planning-breach-store',
  persist: true,
  enableDevTools: false,
});
